export default __webpack_public_path__ + "static/media/Loyalty Benefit Icon.fbd7a09d.png";